export default {
  show ({ commit }) {
    commit('setAttr', {
      name: 'isLoading',
      value: true
    })
  },

  hide ({ commit }) {
    commit('setAttr', {
      name: 'isLoading',
      value: false
    })
  }
}
